import { Button } from "@/components/ui/button";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Separator } from "@/components/ui/separator";
import { crmRegistry } from "@/features/crm_system/lib/_core/crmRegistry";
import { QuestionsList } from "@/features/question/components/molecules/QuestionsList";
import { SurveyBankWithQuestions, SurveyDetailsDialogProps, SurveyOrSurveyBankWithQuestions } from ".";

function isSurveyBankWithQuestions(survey: SurveyOrSurveyBankWithQuestions): survey is SurveyBankWithQuestions {
    return 'survey_bank_question_bank' in survey;
}

function hasGroupedQuestions(survey: SurveyOrSurveyBankWithQuestions): boolean {
    return 'grouped_questions' in survey;
}



export function SurveyDetailsDialog<S extends SurveyOrSurveyBankWithQuestions>({
    survey,
    groupQuestions = true,
    ...props
}: Readonly<SurveyDetailsDialogProps<S>>) {
    return (
        <Dialog {...props}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{survey.name}</DialogTitle>
                    <DialogDescription>{survey.description}</DialogDescription>
                </DialogHeader>
                <Separator />
                {isSurveyBankWithQuestions(survey) && (
                    <div className="text-sm">
                        <p className="text-xs">CRM system:</p>
                        <p>{crmRegistry.getSystemById(survey.crm_system)?.name}</p>
                    </div>
                )}
                <Separator />
                <div className="h-72">
                    <ScrollArea className="h-full">
                        <QuestionsList
                            questions={(() => {
                                if (hasGroupedQuestions(survey) && groupQuestions) {
                                    return survey.grouped_questions ?? [];
                                }
                                return isSurveyBankWithQuestions(survey) ? survey.survey_bank_question_bank : survey.question;
                            })()}
                        />
                    </ScrollArea>
                </div>
                <Separator />
                <DialogFooter>
                    <DialogClose asChild>
                        <Button size='sm'>Close</Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}


